import api from "API/api";
import { toast } from "sonner";
import React, { useState } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import { WarningRounded} from "@mui/icons-material";

const DeleteDeviceModal = ({
  deleteDeviceOpen,
  setDeleteDeviceOpen,
  selectedDevice,
  getSitesList,
}) => {
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setDeleteDeviceOpen(false);
  };

  const handleDelete = async () => {
    if (!selectedDevice) return;

    try {
      setLoading(true);
      let payload = {
        device_id: selectedDevice?.device_id,
        site_id: selectedDevice?.site_id,
      };

      const response = await api.delete(`/cv/deviceapi`, { data: payload });
      toast.success(response?.data?.message || "Device deleted successfully!");
      getSitesList();
      handleClose();
    } catch (error) {
      toast.error(error.response?.data?.message || "Error deleting device");
      console.error("Error deleting device:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal open={deleteDeviceOpen} onClose={handleClose}>
        <Box
          sx={{
            outline:'none',
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            textAlign: "center",
          }}
          className="delete-device-modal"
        >
          <Box sx={{ marginBottom: "40px" }}>
            <Box sx={{ display: "flex" }}>
              <Typography
                color="error"
                sx={{
                  background: "rgb(250 212 212)",
                  width: "50px",
                  height: "50px",
                  borderRadius: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "4px",
                }}
              >
                <WarningRounded />
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  marginLeft: "12px",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontSize: "18px", marginBottom: "5px" }}
                >
                  Delete Device
                </Typography>
                <Typography sx={{ fontSize: "13px", color: "#9c9b9b" }}>
                  Are you sure you want to delete this device?
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={handleClose}
              sx={{
                textTransform: "none",
                width: "48%",
                border: "1px solid gray",
                color: "gray",
                fontWeight: "500",
                fontSize: "15px",
              }}
              variant="outlined"
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "48%",
                fontWeight: "500",
                fontSize: "15px",
                background: "#fc4f4f",
                color: "white !important",
                "&:hover": {
                  background: "#fc4f4f",
                  color: "white !important",
                },
              }}
              onClick={handleDelete}
              disabled={loading}
            >
              {loading ? "Deleting..." : "Delete"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DeleteDeviceModal;
